module.exports = __webpack_public_path__ + "files/821b48093e33cb4088b1fc246a8311f6.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/default.png
// module id = 540
// module chunks = 76